// @flow
import superagentRequest from 'superagent';
import throwError from './throwError';

const loadEnvVar = (name) => {
  if (!process.env[name]) throw new Error(`process.env.${name} required`);
  return process.env[name];
};
export const BASE_URL = loadEnvVar('REACT_APP_API_END_POINT');

export const makeGetRequest = (endpoint, data) => {
  if (data !== undefined) {
    return superagentRequest
      .get(`${BASE_URL}${endpoint}`)
      .query(data)
      .set('Accept', 'application/json')
      .withCredentials() // Enable cross-domain cookies
      .catch(throwError);
  }

  return superagentRequest
    .get(`${BASE_URL}${endpoint}`)
    .set('Accept', 'application/json')
    .withCredentials() // Enable cross-domain cookies
    .catch(throwError);
};

export const makePostRequest = (endpoint, data) => {
  if (endpoint !== '/login') {
    return superagentRequest
      .post(`${BASE_URL}${endpoint}`)
      .send(data)
      .set('Accept', 'application/json')
      .withCredentials() // Enable cross-domain cookies
      .catch(throwError);
  }
  return superagentRequest
    .post(`${BASE_URL}${endpoint}`)
    .send(data)
    .set('Accept', 'application/json')
    .withCredentials() // Enable cross-domain cookies
    .catch(throwError);
};

export const makePutRequest = (endpoint, data) => {
  if (data === undefined) {
    return superagentRequest
      .put(`${BASE_URL}${endpoint}`)
      .withCredentials() // Enable cross-domain cookies
      .catch(throwError);
  }
  return superagentRequest
    .put(`${BASE_URL}${endpoint}`)
    .send(data)
    .set('Accept', 'application/json')
    .withCredentials() // Enable cross-domain cookies
    .catch(throwError);
};
